/**
 * @param hasUnlockedExtraFreeSamples
 * @param shouldShowSpendMoreToUnlockExtraFreeSamplesBanner
 * @param isCartReady
 * @param isSelectFreeBonusDeluxeSamplesStep
 * @param shouldShowMinimumToCheckOutBanner
 * @param isPostSampleSurveyUrl
 * @returns {boolean}
 */
export const shouldShowUnlockedExtraFreeSamplesBannerCartSelectUtil = ({
  hasUnlockedExtraFreeSamples,
  shouldShowSpendMoreToUnlockExtraFreeSamplesBanner,
  isCartReady,
  isSelectFreeBonusDeluxeSamplesStep,
  shouldShowMinimumToCheckOutBanner,
  isPostSampleSurveyUrl
}) => {
  if (isPostSampleSurveyUrl) {
    return false
  }

  if (shouldShowMinimumToCheckOutBanner) {
    return false
  }

  if (isSelectFreeBonusDeluxeSamplesStep) {
    return false
  }

  if (!isCartReady) {
    return false
  }

  if (shouldShowSpendMoreToUnlockExtraFreeSamplesBanner) {
    return false
  }

  return !!hasUnlockedExtraFreeSamples
}
